// every language, english included, goes to its own domain from the cms
// redirectUrl. only the language code is derived here, for the cookie.

// region suffixes are two letters ("en-CA"), brand suffixes are not ("en-bison")
const REGION_SEGMENT = /^[a-z]{2}$/i;

// "en-bison" -> "en", "en-IN-fireball" -> "en-IN", "en-CA" -> "en-CA",
// "luckera-hu" -> "hu", "Lucera - en" -> "en"
export function extractLanguageCode(rawName: string | null | undefined): string {
  if (!rawName) {
    return '';
  }
  const parts = rawName.split('-').map((part) => part.trim()).filter(Boolean);
  if (!parts.length) {
    return '';
  }
  if (parts.length > 1 && !REGION_SEGMENT.test(parts[parts.length - 1])) {
    parts.pop();
  }
  while (parts.length > 1 && !REGION_SEGMENT.test(parts[0])) {
    parts.shift();
  }
  return parts.join('-');
}
